import { AvatarMenu } from '@/components/Shared/AvatarMenu/AvatarMenu';
import { Avatar } from '@/components/Shared/Avatar';
import css from '@/components/Shared/AvatarWithMenu.module.css';
import theme from '@/styles/DybrTheme';
import { classNames } from '@/utils/helpers/classNames';
import { useState } from 'react';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import { ARROW_HEIGHT } from './constants';

function AvatarWithMenu({ profile, className, subAvatar = false }) {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const arrowContentRenderer = ({ position, childRect, popoverRect }) => (
    <ArrowContainer
      position={position}
      childRect={childRect}
      popoverRect={popoverRect}
      arrowColor={theme.backgroundLighter}
      arrowSize={ARROW_HEIGHT}
      arrowStyle={{ marginLeft: subAvatar ? '20px' : '0px' }}
      className={classNames({
        [css.popoverArrowContainer]: true,
        [css.popoverArrowContainerSmall]: subAvatar
      })}
    >
      <AvatarMenu profile={profile} />
    </ArrowContainer>
  );

  return (
    <div className={className}>
      <Popover
        padding={5}
        isOpen={isMenuOpen}
        positions={['bottom']}
        align={'center'}
        content={arrowContentRenderer}
        onClickOutside={() => setMenuOpen(false)}
        disableReposition={true}
        transitionDuration={0.1}
      >
        <Avatar profile={profile} onClick={() => setMenuOpen(!isMenuOpen)} />
      </Popover>
    </div>
  );
}

export default AvatarWithMenu;
